
import React from 'react'

import CrudTable from '../../../shared/CrudTable'

const tableDefinition = [
  {
    title: 'Products',
      displayFn: v => ((v?.products ?? []) || []).join(', ')
  },
  {
    title: 'Status',
    displayFn: v => v.status
  },
  {
    title: 'LCM Provider',
      displayFn: v => ((v?.lCMProvider ?? []) || []).join(', ')
  },
  {
    title: 'Enroll',
    displayFn: v => v.enroll
  },
  {
    title: 'General Support',
    displayFn: v => v.generalSupport
  },
  {
    title: 'Enroll Exceptions',
    displayFn: v => v.enrollExceptions?.join(', ') || 'None'
  },
  {
    title: 'Claims Threshold',
      displayFn: v => v?.claimsThreshold ?? 'None'
  },
  {
    title: 'Self-Enrollment',
    displayFn: v => v.selfEnrollment
  },
  {
    title: 'Client Requests',
    displayFn: v =>
        ((v?.clientRequests ?? 'None') || '')
        .split('\n')
        .map((item, key) => (
          <span key={key}>
            {item}
            <br />
          </span>
        ))
  }
]

class Services extends React.Component {
  constructor (props) {
    super(props)
    const { clientName } = this.props

    this.urls = {
      get: () => `/crm/services/${clientName}`
    }

    this.mapFns = {
      toForm: a => a
    }
  }

  render () {
    const { inModal } = this.props
    return (
      <div className='main'>
        <CrudTable
          entryType='service'
          tableDefinition={tableDefinition}
          urlFns={this.urls}
          mapFns={this.mapFns}
          readOnly={inModal}
        />
      </div>
    )
  }
}

export default Services
